import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Response, ResponseContentType } from "@angular/http";
import { AuthHttp } from 'angular2-jwt';
import { Observable } from "rxjs/Observable"
import "rxjs/add/operator/map";

@Injectable()
export class UserManagementRoleApiService {

    constructor(
        private userManagementRoleApi: Http,
        private authHttp: AuthHttp
    ) { }

    GetUserManagementRoleApi(page, pageSize, searchType, searchText) {
        var formData = new FormData();
        formData.append("page", page);
        formData.append("pageSize", pageSize);
        formData.append("searchType", searchType);
        formData.append("searchText", searchText);

        return this.authHttp.post(environment.apiEndPoint + '/UserManagement', formData)
            .map((response: Response) => response.json());
    }

    edit(data) {
        let formData : FormData = new FormData();
        formData.append("UserName", data.UserName);
        formData.append("RoleId", data.UserRoleId);
        return this.authHttp.post(environment.apiEndPoint + '/UserManagement/Edit', formData)
          .map((response : Response) => response.json())
    }

    delete(data){
        let formData : FormData = new FormData();
        formData.append("UserName", data);
        
        return this.authHttp.post(environment.apiEndPoint + '/UserManagement/Delete', formData)
          .map(((response : Response) => response.json()))
    }

    GetListRole() {
        return this.authHttp.get(environment.apiEndPoint + '/UserManagement/GetListRole')
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/UserManagementRoleApi.service.ts